import getConfig from 'next/config';

import merge from 'lodash/merge';

import {loadExternalDependency, waitForCondition} from '~/src/utilities/helpers/dependency';
import rollbar from '~/src/utilities/libs/rollbar';
import {Cookie} from '~/src/utilities/constants/cookie';
import {getCookieJson} from '~/src/utilities/helpers/cookie';

const {publicRuntimeConfig: config} = getConfig();

let eventQueue = {};

const daktIsReady = async () => {
    await waitForCondition(() => window.Dakt2, 1000);
};

const initUserID = () => {
    const sessionUser = getCookieJson(Cookie.SESSION);
    window.tamediaBID = sessionUser && sessionUser.userIdExternalIDP;
};

const loadBeagleDependency = async () => {
    initUserID();

    try {
        await loadExternalDependency({src: config.scripts.beagle});
    } catch (error) {
        rollbar.warning(`[beagle] Error while loading beagle dependency: ${error.message}`, error);
    }
};

const trackRouteChange = () => {
    loadBeagleDependency();
    window.beagleQueue.push({init: true});
};

const trackEvent = (type, data) => {
    if (type) {
        loadBeagleDependency();
        window.beagleQueue.push({
            name: type,
            data: data
        });
    }
};

const isEventRegistered = (type) => !!eventQueue[type];

const deleteEvent = (type, keepLastItem = false) => {
    if (isEventRegistered(type)) {
        if (keepLastItem) {
            eventQueue[type] = eventQueue[type].slice(-1);
        } else {
            delete eventQueue[type];
        }
    }
};

const registerEvent = (type, data) => {
    if (!isEventRegistered(type)) {
        eventQueue[type] = [];
    }
    eventQueue[type].push(data);
};

const triggerEvent = (type, additionalData) => {
    if (isEventRegistered(type)) {
        eventQueue[type].forEach((data) => {
            if (additionalData) {
                data = merge(data, additionalData);
            }
            trackEvent(type, data);
        });
        deleteEvent(type);
    }
};

export {daktIsReady, loadBeagleDependency, trackRouteChange, trackEvent, isEventRegistered, deleteEvent, registerEvent, triggerEvent};
